import { useCallback, useEffect, useMemo, useState } from 'react';
import { get_Users } from 'services/users-roles';
import { delete_Roles, edit_User, get_all_role } from 'services/auth/permission';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import Modal_AddRole from 'components/Modals/Modal_AddRole';
import { format } from 'date-fns';
import Modal_EditRole from 'components/Modals/Modal_EditRole';
import Table from 'components/Table';
import { FUNCTION, PATH } from './defineroles';
import checkPermissionFunction from 'Permission';

const AuthorityRole = () => {
  const [Users, setUsers] = useState([]);
  const [pending, setPending] = useState(true);

  const [roles, set_Roles] = useState([]);
  const [rolesInSearch, set_RolesInSearch] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleDeleteRole = async (selectedRows) => {
    let check = null;

    await Swal.fire({
      title: t('Notification'),
      text: 'Bạn có chắc chắn muốn xóa vai trò này không?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    }).then(async function (result) {
      if (result.value) {
        check = true;
      } else {
        check = false;
      }
    });

    (await check) != null;

    if (check == false) return;

    const res = await delete_Roles(selectedRows.map((item) => item.roleId));
    Swal.fire({
      title: t('Notification'),
      text: res.data.message,
      icon: 'warning',
      // showCancelButton: true,
      confirmButtonText: t('Yes'),
      // cancelButtonText: t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    });

    if (res.data.status == 0) return;

    refresh_Roles();
  };

  const confirmUpdate = async (values, actions) => {
    const res = await edit_User(values);

    Swal.fire({
      title: t('Notification'),
      text: res.data.message,
      icon: 'warning',
      // showCancelButton: true,
      confirmButtonText: t('Yes'),
      // cancelButtonText: t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    });

    if (res.data.status == 0) return;

    actions.resetForm();

    refresh_Roles();
  };

  const handleEditRole = async (row) => {
    set_SelectedRow(row);
    set_click_Edit(true);
  };

  const columns = [
    {
      name: 'TÊN VAI TRÒ',
      selector: (row) => row.name,
      hide: 'sm',
    },
    {
      name: 'TỔNG SỐ NGƯỜI DÙNG',
      selector: (row) => Users.filter((item) => item.roleId == row.roleId).length,
    },
    // {
    //     name: 'SỐ LƯỢNG QUYỀN HẠN',
    //     selector: row => row.email,
    //     hide: 'md',
    // },
    {
      name: 'NGÀY TẠO',
      selector: (row) => format(row.createdAt, 'dd/MM/yyyy'),
      hide: 'md',
    },
    {
      name: 'CẬP NHẬT GẦN NHẤT',
      selector: (row) => format(row.updatedAt, 'dd/MM/yyyy'),
      hide: 'md',
    },
    {
      name: '',
      cell: (row) => (
        <div className="d-flex align-content-center w-full gap-2">
          {
            row.name != "admin" && (
              <KTTooltip text="Chỉnh sửa">
                <a
                  className="btn btn-icon btn-sm btn-light-primary btn-hover-primary"
                  onClick={() => {
                    checkPermissionFunction(PATH.AuthorityRole, FUNCTION.edit, () =>
                      handleEditRole(row)
                    );
                  }}
                >
                  <i className="fa fa-pen p-0 icon-1x"></i>
                </a>
              </KTTooltip>
            )
          }
          {row.name != 'admin' && (
            <KTTooltip text="Xóa">
              <a
                className="btn btn-icon btn-sm btn-light-danger btn-hover-danger"
                onClick={() => {
                  checkPermissionFunction(PATH.AuthorityRole, FUNCTION.delete, () =>
                    handleDeleteRole([row])
                  );
                }}
              >
                <i className="fa fa-trash p-0 icon-1x"></i>
              </a>
            </KTTooltip>
          )}
        </div>
      ),
      button: true,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const response = await get_Users();
      setUsers(response.data);
      refresh_Roles();
    };
    fetchData();
  }, []);

  const handleSubmit = async () => {
    refresh_Roles();
  };

  const refresh_Roles = async () => {
    setPending(true);
    const roles = await get_all_role();

    set_Roles(roles.data.data);
    set_RolesInSearch(roles.data.data);
    setPending(false);
  };

  const [initialValues, set_initialValues] = useState({
    screenCodes: [],
  });

  const [selectedRow, set_SelectedRow] = useState(null);

  const reset_initialValues = () => {
    set_click_Add(true);
    set_initialValues({
      username: '',
      email: '',
      fullname: '',
      phone: '',
      password: '',
      roleId: '',
    });
  };

  const [click_Add, set_click_Add] = useState(false);
  const [click_Edit, set_click_Edit] = useState(false);

  return (
    <div className="container-fluid min-h-100">
      <div className="h-100">
        <div className="card card-custom h-100">
          <div className="card-header border-0 pt-6 pb-0">
            <div className="w-100 d-flex justify-content-between">
              <div className="card-title my-0">
                <h3 className="card-label">
                  Danh sách vai trò
                  <span className="text-dark pt-2 font-size-sm d-block">
                    Tổng: {roles.length} Vai trò
                  </span>
                </h3>
              </div>
              <div className="card-toolbar gap-2">
                <div
                  className={`${selectedRows.length == 0 ? 'd-none' : ''
                    } btn btn-light-danger font-weight-bold align-items-center`}
                  onClick={() => {
                    checkPermissionFunction(PATH.AuthorityRole, FUNCTION.delete, () =>
                      handleDeleteRole(selectedRows)
                    );
                  }}
                >
                  <i className="fa fa-ban"></i>Xóa ({selectedRows.length})
                </div>
                <div
                  className="btn btn-primary font-weight-bold d-flex align-items-center"
                  onClick={() => {
                    checkPermissionFunction(PATH.AuthorityRole, FUNCTION.add, () =>
                      reset_initialValues()
                    );
                  }}
                >
                  <i className="fa fa-plus"></i>
                  Thêm vai trò
                </div>
                {click_Add == true && (
                  <div
                    className="modal fade show"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    style={{ display: 'block', paddingRight: '6px' }}
                    role="dialog"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-xl">
                      <Modal_AddRole
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        dismiss={() => set_click_Add(false)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="input-icon mr-2 mt-4 mr-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm kiếm..."
                  onChange={(e) => {
                    const value = e.target.value.toLowerCase();
                    const data = roles.filter((item) => item.name.toLowerCase().includes(value));
                    set_RolesInSearch(data);
                  }}
                />
                <span className="h-100">
                  <i className="fal fa-search text-muted"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="card-body py-3 d-flex flex-column justify-content-between">
            <Table
              data={rolesInSearch}
              columns={columns}
              maxHeight={60}
              values={(value) => setSelectedRows(value)}
              progressPending={pending}
            />
          </div>
        </div>
      </div>
      {click_Edit == true && (
        <div
          className="modal fade show"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          style={{ display: 'block', paddingRight: '6px' }}
          role="dialog"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <Modal_EditRole
              row={selectedRow}
              onSubmit={handleSubmit}
              dismiss={() => set_click_Edit(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default AuthorityRole;
